import "../pages/HealthCheckPage.css";

import React, {memo} from "react";

import {healthcheckService} from "../services/healthcheckService";
import FileUploader from "shared/components/fileUploader";

const GeneralFileUploader = ({manNameN, currFileLen, setCurrFileLen, currFileName, setCurrFileName}: {manNameN: string, currFileLen: number, setCurrFileLen: React.Dispatch<React.SetStateAction<number>>, currFileName: string, setCurrFileName: React.Dispatch<React.SetStateAction<string>>}) => {
    return (
        <FileUploader
            handleUploadFn={(fl: File) => healthcheckService.uploadCompressedCsv(manNameN, fl)}
            handleDownloadFn={async () => {return await healthcheckService.exportGeneralResult(manNameN)}}
            currFileName={currFileName}
            currFileLen={currFileLen}
            setCurrFileName={setCurrFileName}
            setCurrFileLen={setCurrFileLen}
            reUploadMessage={`Re-Upload Full List (Previous has ${currFileLen} products)`}
        />
    );
};

export default memo(GeneralFileUploader);
